// Textbook modules, keyed by spec topic-code prefix. A board shows only the
// modules that actually have topics (ESAT has the five subject ones; TMUA has
// Mathematics 2 and Mathematical Reasoning).
export type TextbookModule = { slug: string; prefixes: string[]; name: string; blurb: string };

export const TEXTBOOK_MODULES: TextbookModule[] = [
  { slug: "maths-1", prefixes: ["M"], name: "Mathematics 1", blurb: "Core mathematics: number, algebra, ratio, and the foundations you are expected to be fluent in." },
  { slug: "maths-2", prefixes: ["MM"], name: "Mathematics 2", blurb: "Advanced mathematics: functions, coordinate geometry, sequences, trigonometry, and calculus." },
  { slug: "mathematical-reasoning", prefixes: ["ARG", "PRF", "ERR"], name: "Mathematical Reasoning", blurb: "Logic and proof: what follows from what, necessary and sufficient conditions, and where a written argument goes wrong." },
  { slug: "physics", prefixes: ["P"], name: "Physics", blurb: "Mechanics, electricity, magnetism, waves, and the physics the exam expects you to apply." },
  { slug: "chemistry", prefixes: ["C"], name: "Chemistry", blurb: "Atomic structure, bonding, reactions, and quantitative chemistry across the syllabus." },
  { slug: "biology", prefixes: ["B"], name: "Biology", blurb: "Cells, physiology, genetics, ecosystems, and the biology the exam draws on." },
];

// Longest prefix first so "MM" wins over "M".
const BY_PREFIX: { prefix: string; module: TextbookModule }[] = TEXTBOOK_MODULES.flatMap((module) =>
  module.prefixes.map((prefix) => ({ prefix, module })),
).sort((a, b) => b.prefix.length - a.prefix.length);

export function moduleForTopicId(topicId: string): TextbookModule | null {
  const code = (topicId.match(/^[A-Za-z]+/)?.[0] || "").toUpperCase();
  return BY_PREFIX.find((p) => code === p.prefix)?.module ?? null;
}

export function findModuleBySlug(slug: string): TextbookModule | null {
  return TEXTBOOK_MODULES.find((m) => m.slug === slug) ?? null;
}

/** "maths-2/algebra-and-functions/laws-of-indices" -> "Laws Of Indices". */
export function titleFromSlug(slug: string): string {
  const part = slug.split("/").pop()!;
  let t = part
    .replace(/-/g, " ")
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
  if (part.startsWith("mm")) t = "MM" + t.slice(2);
  return t;
}
